import { NgModule } from '@angular/core';
import { LoginComponent } from './components/login/login.component';
import { AppointmentComponent } from './components/appointment/appointment.component';
import { RelevantLabDocumentComponent } from './components/relevant-lab-document/relevant-lab-document.component';
import { RelevantLabComponent } from './components/relevant-lab/relevant-lab.component';
import { AuthGuard } from './services/guard';
import { RouterModule, Routes } from '@angular/router';
import { Role } from './models/role.model';
import { RedirectComponent } from './components/redirect/redirect.component';

const routes: Routes = [
  {
    path: "admin",
    canActivate: [AuthGuard],
    data: {
      role: Role.Admin
    },
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule)
  },
  {
    path: "doctor",
    canActivate: [AuthGuard],
    data: {
      role: Role.Doctor
    },
    loadChildren: () => import('./doctor/doctor.module').then((m) => m.DoctorModule)
  },
  {
    path: "expert",
    canActivate: [AuthGuard],
    data: {
      role: Role.Expert
    },
    loadChildren: () => import('./expert/expert.module').then((m) => m.ExpertModule)
  },
  {
    path: "hospital",
    canActivate: [AuthGuard],
    data: {
      role: Role.Hospital
    },
    loadChildren: () => import('./hospital/hospital.module').then((m) => m.HospitalModule)
  },
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: 'login', component: LoginComponent },
  { path: 'redirect', component: RedirectComponent },
  { path: 'appointment/:id', component: AppointmentComponent, canActivate: [AuthGuard] },
  { path: 'relevant-lab/:id', component: RelevantLabComponent, canActivate: [AuthGuard] },
  { path: 'relevant-lab-document/:id/:type', component: RelevantLabDocumentComponent, canActivate: [AuthGuard] },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
